import {inject} from '@angular/core';
import {ResolveFn} from '@angular/router';
import {map} from 'rxjs/operators';
import {ProductStatInterface} from '../../models/product-stat.interface';
import {ProcessorListService} from '../../../processor/services/processor-list.service';
import {Processor} from '../../../processor/models/processor.model';

/**
 * Restructure array of processors into a map of product -> processor[], skipping inactive processors
 */
export function groupProcessorsByProduct(procs: Array<Processor>): Map<number, ProductStatInterface> {
  const results = new Map<number, ProductStatInterface>();

  procs
    .filter((v) => v.active)
    .forEach((v) => {
      const existing = results.get(v.product_id);

      if (existing) {
        existing.processors.push(v);
      } else {
        results.set(v.product_id, {
          id: v.product_id,
          name: v.product_name,
          processors: [v],
        });
      }
    });

  return results;
}

export const rrHomeResolver: ResolveFn<Map<number, ProductStatInterface>> = () => {
  return inject(ProcessorListService)
    .get(true)
    .pipe(map(groupProcessorsByProduct));
};
